export const VillageBackground = () => {
  return (
    <div className='absolute right-0 bottom-0 -z-10'>
      <img src={'/images/village/base/bg.png'} alt='background' />
    </div>
  );
};
